import { ClaimEditValues } from 'api/endpoints';
import {
  ResolutionSubstatus,
  ResolutionTypeId,
} from 'api/endpoints/actions-select-options';
import { useAppUserType } from 'utils/hooks/useAppUserType';
import { AP_USER_DEFAULT_SECTIONS } from '../const/apUser';
import {
  CLIENT_SECTIONS,
  CLIENT_SECTIONS_EXPUNGE,
  CLIENT_SECTIONS_EXPUNGE_NOSURVIVING,
} from '../const/clientUser';

export const useSections = (claim: ClaimEditValues | undefined) => {
  const { resolutionTypeId, actionSubStatusId } = claim ?? {};

  const { isClient, isApUser } = useAppUserType();

  if (isApUser) {
    return AP_USER_DEFAULT_SECTIONS;
  }

  if (isClient) {
    if (resolutionTypeId !== ResolutionTypeId.Expunge) {
      return CLIENT_SECTIONS;
    }

    const isSurviving = expungeWithSurviving.includes(
      actionSubStatusId as ResolutionSubstatus,
    );
    return isSurviving
      ? CLIENT_SECTIONS_EXPUNGE
      : CLIENT_SECTIONS_EXPUNGE_NOSURVIVING;
  }

  return CLIENT_SECTIONS;
};

const expungeWithSurviving = [
  ResolutionSubstatus.AmendedReplacedClaims,
  ResolutionSubstatus.DuplicativeClaims,
  ResolutionSubstatus.RedundantClaims,
  ResolutionSubstatus.SatisfiedDuringCaseClaims,
  ResolutionSubstatus.NoBasisClaims,
  ResolutionSubstatus.NoLiabilityClaims,
  ResolutionSubstatus.AnticipatedWithdrawal,
  ResolutionSubstatus.NoSupportClaims,
  ResolutionSubstatus.LateFiledClaims,
  ResolutionSubstatus.EquityInterestClaims,
  ResolutionSubstatus.ContractAssumedClaims,
  ResolutionSubstatus.AnticipatoryContractRejectionClaims,
  ResolutionSubstatus.BeneficialBondholderClaims,
];
